import { Component, Prop, Emit, Watch, Vue } from 'vue-property-decorator'
import { Action, Getter, State, Mutation } from 'vuex-class'
import AsideCart from '@/components/asideCart/asideCart'

@Component({
  components: {
    AsideCart
  }
})
export default class LayoutProducts extends Vue {

  get getHeader() {
    const name = this.$route.name
    return name !== 'checkout'
  }

}
